<template>
	<div
		class="section-switch"
	>
		<div class="label">
			{{ label }}
		</div>
		<div class="enabled-checkbox">
			<SwitchInput
				:value="value"
				:disabled="!editable"
				@input="$emit('input', $event)"
			/>
		</div>
	</div>
</template>

<script>
import SwitchInput from '@components/Switch/Switch';
export default {
	name:       'SectionSwitch',
	components: { SwitchInput },
	props:      {
		value: {
			type:    Boolean,
			default: true,
		},
		editable: {
			type:    Boolean,
			default: true,
		},
		label: {
			type:    String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.section-switch {
	display: flex;
	justify-content: space-between;
	padding: 18px 0;
	width: 100%;
}

::v-deep .switch.on .switch__input {
	background: var(--color-green-petrol);

	&__indicator {
		transform: translateX(30px);
		border: 2px solid var(--color-green-petrol);
		background: var(--color-soft-white);
	}
}
</style>
